import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {useHistory} from 'react-router-dom';
import Skeleton from '@material-ui/lab/Skeleton';

function CountView(props) {
  const history = useHistory();
  function handleGoToSubcontractorList() {
    history.push('/global-subcontractors');
  }

  return (
    <div className="card mb-3">
      <div className="card-header">
        <div className="card-title"><Translate value="globalDashboard.mySubcontractors"/></div>
      </div>
      <div
        className="flex-container column center space-between"
        style={{height: 'calc(100% - 48px)'}}
      >
        <div className="simple-number-stats mb-5 w-100">
          <div className="number flex-container column center information-primary">
            {props.loading ?
              <Skeleton
                variant="rect"
                height={62}
                width={41}
              /> :
              props.count
            }
          </div>
          <div className="label w-100">
            {props.loading ?
              <Skeleton variant="text"/> :
              <Translate value="globalDashboard.subcontractorsLabel"/>
            }
          </div>
        </div>
        <button
          type="button"
          className="small link"
          disabled={props.count < 1}
          onClick={handleGoToSubcontractorList}
        >
          <Translate value="globalDashboard.seeAllSubcontractors"/>
        </button>
      </div>
    </div>
  );
}

CountView.propTypes = {
  count: PropTypes.number.isRequired,
  loading: PropTypes.bool
};

export default CountView;
